import { CameraBrand } from './types';

/**
 * Fetches camera taxonomy from the BFF.
 * The BFF handles E2E token authentication with studiogateway.
 */
export const getCameras = async (): Promise<CameraBrand[]> => {
  const response = await fetch('/api/cameras');

  if (!response.ok) {
    throw new Error(`Failed to fetch cameras: ${response.statusText}`);
  }

  return response.json();
};
